<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">拓客利器</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">快商宝</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="vistor-content">
            <div class="search-vistor">
                <svg width="100%"  viewBox="0 0 1204 227" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
                    <title>pic_bluebottom</title>
                    <desc>Created with Sketch.</desc>
                    <defs>
                        <rect id="path-1" x="0" y="0.590703907" width="100%" height="100%" rx="4"></rect>
                        <linearGradient x1="122.782781%" y1="58.1847735%" x2="23.8099564%" y2="58.1847735%" id="linearGradient-3">
                            <stop stop-color="#87B2FF" offset="0%"></stop>
                            <stop stop-color="#4F7AFD" offset="100%"></stop>
                        </linearGradient>
                        <linearGradient x1="0.142457637%" y1="46.4284144%" x2="100%" y2="46.4284144%" id="linearGradient-4">
                            <stop stop-color="#FFFFFF" stop-opacity="0.0755026224" offset="0.0475084459%"></stop>
                            <stop stop-color="#FFFFFF" stop-opacity="0" offset="100%"></stop>
                        </linearGradient>
                        <linearGradient x1="50.0237542%" y1="28.8282406%" x2="50.0237542%" y2="103.206492%" id="linearGradient-5">
                            <stop stop-color="#FFFFFF" stop-opacity="0.0440887238" offset="0.0475084459%"></stop>
                            <stop stop-color="#FFFFFF" stop-opacity="0" offset="100%"></stop>
                        </linearGradient>
                        <linearGradient x1="25.6598065%" y1="46.8111555%" x2="58.9564892%" y2="50%" id="linearGradient-6">
                            <stop stop-color="#FFFFFF" offset="0%"></stop>
                            <stop stop-color="#DBE4FF" stop-opacity="0.403985507" offset="100%"></stop>
                        </linearGradient>
                    </defs>
                    <g id="快商宝" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="画板" transform="translate(-58.000000, -138.000000)">
                            <g id="pic_bluebottom" transform="translate(58.000000, 137.000000)">
                                <g id="矩形备份-9-+-矩形-+-矩形备份-3-+-矩形备份-10-+-矩形备份-8-+-Shape-蒙版" transform="translate(0.000000, 0.409296)">
                                    <mask id="mask-2" fill="white">
                                        <use xlink:href="#path-1"></use>
                                    </mask>
                                    <use id="蒙版" fill="#FFFFFF" xlink:href="#path-1"></use>
                                    <rect id="矩形备份-9" fill="url(#linearGradient-3)" mask="url(#mask-2)" x="0" y="0.590703907" width="100%" height="227" rx="4"></rect>
                                    <g id="编组备份" mask="url(#mask-2)">
                                        <g transform="translate(-78.000000, -76.258488)">
                                            <polygon id="矩形备份-10" fill="url(#linearGradient-4)" points="362.245322 0.849191501 440 67.2940979 77.7546778 376.849192 0 310.404285"></polygon>
                                            <polygon id="矩形备份-8" fill="url(#linearGradient-5)" points="463.218009 28.8491915 487 49.1809451 124.781991 358.849192 101 338.517438"></polygon>
                                        </g>
                                    </g>
                                    <path d="M1147.48455,182.548336 L1147.48684,182.763884 C1139.29039,192.873332 1127.42498,206.013502 1093.53839,185.421551 C1065.68956,162.685754 1054,134.220871 1054,97.1840391 C1054,30.0298944 1108.84512,-24.4092961 1176.5,-24.4092961 C1244.15488,-24.4092961 1299,30.0298944 1299,97.1840391 C1299,134.934289 1281.52931,169.193085 1253.64218,191.664364 C1252.14098,193.078959 1250.27359,194.591575 1248.03999,196.202214 C1240.61065,201.559486 1232.62146,206.155804 1223.91398,210.694766 C1205.2426,222.37127 1182.5907,232.164219 1155.95826,240.073612 L1155.95826,249.419428 C1169.81529,245.175352 1183.21593,240.183373 1196.15932,234.44349 C1216.5038,225.420999 1230.62394,218.121495 1238.51974,212.544125 L1238.51974,222.536593 C1238.51974,233.380769 1232.7816,243.41663 1223.43232,248.924229 C1217.93089,252.164294 1211.34977,255.585591 1203.68813,259.186419 C1192.01175,264.675299 1176.87494,270.190556 1158.28025,275.730487 C1156.36612,276.300562 1154.37961,276.590704 1152.38288,276.590704 C1140.98238,276.590704 1131.74038,267.35635 1131.74038,255.964222 L1131.78296,255.954012 L1131.7865,253.721326 C1131.6431,253.925667 1131.5037,254.131602 1131.36842,254.339098 L1131.80254,242.937297 C1131.80765,239.862616 1132.2104,236.855436 1132.97078,233.975665 C1134.70951,223.108811 1142.44841,213.131469 1153.15326,209.375869 C1162.73755,206.013464 1170.36939,203.137912 1176.04963,200.7509 C1182.16349,198.181687 1187.94113,195.787062 1193.50212,193.280733 C1199.59259,190.189367 1206.23864,186.103948 1212.68978,181.6923 C1211.97043,181.112091 1211.29156,180.46284 1210.66276,179.745222 L1179.54491,144.232063 L1149.70617,179.791914 C1149.06859,180.791101 1148.32257,181.715345 1147.48455,182.548336 L1147.48455,182.548336 Z M1119.97368,162.444184 L1119.97368,73.4548738 C1119.97368,64.6330407 1127.21918,57.4815319 1136.15694,57.4815319 C1145.09471,57.4815319 1152.3402,64.6330407 1152.3402,73.4548738 L1152.3402,126.997115 L1205.73551,63.2745912 C1211.43181,56.4765627 1221.63289,55.5235395 1228.52026,61.1459543 C1235.40763,66.7683691 1236.37317,76.8371279 1230.67687,83.6351564 L1200.5604,119.576469 C1200.96368,119.952185 1201.35153,120.351808 1201.722,120.775202 L1235.24659,159.088873 C1236.19855,160.176819 1236.97743,161.355095 1237.5856,162.590704 C1255.18531,146.229143 1266,122.970211 1266,97.5532639 C1266,48.4205987 1225.92949,8.59070391 1176.5,8.59070391 C1127.07051,8.59070391 1087,48.4205987 1087,97.5532639 C1087,120.751938 1095.33984,147.548608 1115.94936,160.237193 C1117.19799,161.005931 1118.53943,161.741595 1119.97368,162.444184 L1119.97368,162.444184 Z M1195.1763,271.909329 C1208.58833,266.185926 1220.82855,259.981292 1231.55818,253.466683 L1233,252.590704 L1232.84036,254.280152 C1230.6063,278.107113 1212.48584,297.829904 1189.75545,301.176262 C1187.83811,301.458836 1185.91228,301.590704 1183.99494,301.590704 C1170.01145,301.590704 1156.40413,294.582875 1148.34842,287.915847 L1147,286.800109 L1148.70336,286.41735 C1166.13857,282.508413 1181.77532,277.627594 1195.1763,271.909329 Z" id="Shape" fill="url(#linearGradient-6)" opacity="0.104236421" mask="url(#mask-2)"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>

                <div class="search-span">
                    <span v-for="(item,i) in serachmenu" :key="i" @click="switchmenu(i)" :class="{active:i==menucurrent}">{{item}}</span>
                </div>

                <div class="search-input">
                    <a-input-search
                    placeholder="输入企业名称、经营范围、地址、产品名称"
                    enter-button="寻一下"
                    @search="onSearch"
                    @keyup.enter="onSearch"
                    />
                </div>
                <a-row class="vistor-menu">
                    <a-col :span="6">
                        <router-link to="/home/paid" >
                            <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"><title>附近企业</title><defs><filter x="-119.4%" y="-82.7%" width="338.9%" height="265.4%" filterUnits="objectBoundingBox" id="filter-1"><feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0   0 0 0 0 0.0449651476   0 0 0 0 0.181951993  0 0 0 0.145214161 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g id="附近企业" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-11" filter="url(#filter-1)" transform="translate(11.857143, 8.428571)"><path d="M8.97959184,7.99360578e-14 C13.9388835,7.99360578e-14 17.9591837,3.95834804 17.9591837,8.8412178 C17.9591837,10.1377789 17.4597134,12.3162777 16.5100197,13.9394892 C15.553566,15.5742552 13.0434233,18.1595987 8.97959184,21.6955198 C4.98233397,18.0993049 2.49476282,15.5139614 1.51687839,13.9394892 C0.412677009,12.1616367 2.00728323e-13,10.2392763 2.00728323e-13,8.8412178 C2.00728323e-13,3.95834804 4.02030021,7.99360578e-14 8.97959184,7.99360578e-14 Z M8.97959184,5.8941452 C7.32649463,5.8941452 5.98639456,7.21359455 5.98639456,8.8412178 C5.98639456,10.4688411 7.32649463,11.7882904 8.97959184,11.7882904 C10.632689,11.7882904 11.9727891,10.4688411 11.9727891,8.8412178 C11.9727891,7.21359455 10.632689,5.8941452 8.97959184,5.8941452 Z" id="形状结合" fill="#FFFFFF"></path><rect id="矩形" fill="#9DB5FE" x="3.76766091" y="22.6697892" width="10.4657248" height="2.47306792" rx="1.23653396"></rect></g></g></svg>
                            <p>附近企业</p>
                        </router-link>
                    </a-col>
                    <a-col :span="6">
                        <router-link to="/home/paid" >
                            <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"><title>寻产品</title><defs><filter x="-76.9%" y="-74.1%" width="253.8%" height="248.1%" filterUnits="objectBoundingBox" id="filter-1"><feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="3.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.309803922   0 0 0 0 0.478431373   0 0 0 0 0.992156863  0 0 0 0.301737325 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter><polygon id="path-2" points="3.36387253 0.0223716861 25.4142541 0.0223716861 25.4142541 24.5885947 3.36387253 24.5885947"></polygon></defs><g id="icon_寻产品" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(8.000000, 8.000000)" id="chanpin-(2)" filter="url(#filter-1)"><path d="M18.4913793,19.5700667 C18.4907996,20.4511755 18.029713,21.2651001 17.2815091,21.7055131 L10.4551188,25.7256669 C9.70663761,26.166157 8.7847417,26.166157 8.03636135,25.7256669 L1.20987023,21.7055131 C0.46186796,21.2649972 0.000680552004,20.4511755 0,19.5700667 L0,11.5290648 C0.000579729484,10.647956 0.461666315,9.83400573 1.20987023,9.39361844 L8.03636135,5.37356747 C8.7847417,4.93294878 9.70663761,4.93294878 10.4551188,5.37356747 L17.2815091,9.39361844 C18.029713,9.83400573 18.4907996,10.647956 18.4913793,11.5290648 L18.4913793,19.5700667 Z" id="Fill-1备份" fill="#9DB5FE"></path><mask id="mask-3" fill="white"><use xlink:href="#path-2"></use></mask><g id="Clip-2"></g><path d="M25.4142541,17.0058481 C25.4135627,18.0359527 24.8636866,18.9875121 23.9714043,19.502399 L15.8304852,24.2023619 C14.9378722,24.717339 13.8384508,24.717339 12.945958,24.2023619 L4.80491873,19.502399 C3.91287686,18.9873918 3.36288057,18.0359527 3.36206897,17.0058481 L3.36206897,7.60511079 C3.36276033,6.57500624 3.91263639,5.62341676 4.80491873,5.10855987 L12.945958,0.408717254 C13.8384508,-0.10641017 14.9378722,-0.10641017 15.8304852,0.408717254 L23.9714043,5.10855987 C24.8636866,5.62341676 25.4135627,6.57500624 25.4142541,7.60511079 L25.4142541,17.0058481 Z" id="Fill-1" fill="#FFFFFF" mask="url(#mask-3)"></path><polyline id="路径-2" stroke="#4F7AFD" stroke-width="1.79310345" stroke-linecap="round" mask="url(#mask-3)" points="8.7166748 8.91491699 14.3881615 12.1413016 20.2830811 8.91491699"></polyline><path d="M14.4618276,12.1034483 C14.4618276,17.072058 14.4745517,19.2042419 14.5,18.5" id="路径-4" stroke="#4F7AFD" stroke-width="1.79310345" stroke-linecap="round" mask="url(#mask-3)"></path></g></g></svg>
                            <p>新增企业</p>
                        </router-link>
                    </a-col>
                    <a-col :span="6">
                        <router-link to="/home/paid" >
                            <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"><title>寻招聘</title><defs><filter x="-67.3%" y="-67.3%" width="234.6%" height="234.6%" filterUnits="objectBoundingBox" id="filter-1"><feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.309803922   0 0 0 0 0.478431373   0 0 0 0 0.992156863  0 0 0 0.3 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g id="icon_寻招聘" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组" filter="url(#filter-1)" transform="translate(9.000000, 8.000000)"><path d="M9.8376762,13.8388788 C11.7892741,13.8388788 13.7408721,14.2641735 15.69247,15.1147629 C18.1113678,16.1690141 19.6753474,18.5567337 19.6753474,21.195391 L19.6753474,23.9379646 C19.6753474,24.4967103 19.2223945,24.9496633 18.6636488,24.9496633 L1.01169865,24.9496633 C0.452952914,24.9496633 -1.91334023e-13,24.4967103 -1.91846539e-13,23.9379646 L-1.91846539e-13,21.195391 C-1.92169681e-13,18.5567322 1.56398085,16.1690114 3.98288134,15.1147626 C5.93448021,14.2641734 7.8860785,13.8388788 9.8376762,13.8388788 Z M14.8143792,1.0658141e-14 L14.8143792,8.7471708 C14.8143792,11.075278 12.9270754,12.9625818 10.5989682,12.9625818 L8.61342987,12.9625818 C6.28532264,12.9625818 4.39801884,11.075278 4.39801884,8.7471708 L4.39801884,4.21541104 C4.39801884,1.88730381 6.28532264,1.0197629e-14 8.61342987,1.0658141e-14 L14.8143792,1.0658141e-14 Z" id="形状结合" fill="#FFFFFF"></path><path d="M18.8968144,0.896551725 L18.8968144,9.04792071 C18.8968144,10.8835482 17.9853731,12.5158447 16.5711697,13.5544601 C17.9658109,13.8093185 19.3604522,14.2226759 20.7550934,14.7945325 C23.3933479,15.8763135 25.1034483,18.355074 25.1034483,21.0973897 L25.1034483,22.1395133 C25.1034483,23.7646735 23.7341486,25.0843624 22.0374118,25.1034401 C22.1801777,24.7095741 22.2587411,24.2799971 22.2587411,23.8301675 L22.2587411,23.8301675 L22.2587411,22.6259357 C22.2587411,19.4570376 20.5486407,16.5926921 17.9103862,15.3426341 C16.5157449,14.6818221 15.7394689,14.2041646 14.3448277,13.9096616 C15.7590311,12.7094838 16.0521072,10.8232745 16.0521072,8.702105 L16.0521072,8.702105 L16.0518277,0.896551725 L18.8968144,0.896551725 Z" id="Combined-Shape" fill="#9EB5FE" transform="translate(19.724138, 12.999996) rotate(1.000000) translate(-19.724138, -12.999996) "></path><path d="M10.4553669,16.5589656 L11.4938895,21.5661567 C11.5233513,21.7082055 11.4845229,21.8558509 11.3889923,21.9650286 L10.2687481,23.2453077 C10.2552141,23.2607752 10.240665,23.2753243 10.2251975,23.2888583 C10.0327788,23.4572247 9.74030472,23.4377264 9.57193835,23.2453077 L8.44933234,21.9623294 C8.35513678,21.8546773 8.31599614,21.709527 8.34329902,21.5691121 L9.30629237,16.6165749 L9.25630464,16.6165749 L8.53874946,15.4739281 C8.40277629,15.2574021 8.46807722,14.9716451 8.68460317,14.835672 C8.75836687,14.7893501 8.84370217,14.7647775 8.93080439,14.7647775 L10.7446898,14.7647775 C11.0003697,14.7647775 11.2076392,14.972047 11.2076392,15.2277269 C11.2076392,15.3148291 11.1830666,15.4001644 11.1367448,15.4739281 L10.4553669,16.5589656 Z" id="Path" fill="#4F7AFD"></path></g></g></svg>
                            <p>高级搜索</p>
                        </router-link>
                    </a-col>
                    <a-col :span="6">
                        <router-link to="/home/paid" >
                            <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"><title>批量查询</title><defs><filter x="-59.3%" y="-64.0%" width="218.5%" height="228.0%" filterUnits="objectBoundingBox" id="filter-1"><feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0   0 0 0 0 0.0449651476   0 0 0 0 0.181951993  0 0 0 0.145214161 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g id="批量" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="编组-36" filter="url(#filter-1)" transform="translate(8.000000, 7.000000)"><path d="M22.364241,5.8968 L3.94455904,5.8968 C1.76603924,5.8968 0,7.67649478 0,9.87185954 L0,20.5193405 C0,22.7147052 1.76603924,24.4944 3.94455904,24.4944 L22.364241,24.4944 C24.5427608,24.4944 26.3088,22.7147052 26.3088,20.5193405 L26.3088,9.87185954 C26.3088,7.67649478 24.5427608,5.8968 22.364241,5.8968 Z" id="路径" fill="#FFFFFF" fill-rule="nonzero"></path><path d="M18.2409988,16.128391 L13.876738,16.128391 L13.876738,20.395046 C13.876738,20.9054422 13.4517944,21.3192 12.9276,21.3192 C12.4034056,21.3192 11.978462,20.9054422 11.978462,20.395046 L11.978462,16.1111171 L7.63194215,16.1111171 C7.15754431,16.0478186 6.804,15.6531903 6.804,15.186963 C6.804,14.7207358 7.15754431,14.3261075 7.63194215,14.262809 L11.978462,14.262809 L11.978462,9.99615402 C11.978462,9.48575785 12.4034056,9.072 12.9276,9.072 C13.4517944,9.072 13.876738,9.48575785 13.876738,9.99615402 L13.876738,14.262809 L18.2232579,14.262809 C18.6976557,14.3261075 19.0512,14.7207358 19.0512,15.186963 C19.0512,15.6531903 18.6976557,16.0478186 18.2232579,16.1111171 L18.2409988,16.128391 Z" id="路径" fill="#4F7AFD" fill-rule="nonzero"></path><path d="M6.77565002,1.8144 L19.07955,1.8144 C19.5649255,1.8144 19.9584,1.40823273 19.9584,0.9072 C19.9584,0.406167275 19.5649255,0 19.07955,0 L6.77565002,0 C6.46166716,0 6.17153502,0.172911331 6.01454358,0.453599992 C5.85755214,0.734288653 5.85755214,1.08011135 6.01454358,1.36080001 C6.17153502,1.64148867 6.46166716,1.8144 6.77565002,1.8144 L6.77565002,1.8144 Z" id="路径" fill="#9DB5FE"></path><path d="M3.1563,4.9896 L22.6989,4.9896 C23.1894945,4.9896 23.5872,4.58343273 23.5872,4.0824 C23.5872,3.58136727 23.1894945,3.1752 22.6989,3.1752 L3.1563,3.1752 C2.66570546,3.1752 2.268,3.58136727 2.268,4.0824 C2.268,4.58343273 2.66570546,4.9896 3.1563,4.9896 L3.1563,4.9896 Z" id="路径" fill="#9DB5FE"></path></g></g></svg>
                            <p>批量查询</p>
                        </router-link>
                    </a-col>
                </a-row>
            </div>

            <div class="tj-company">
                <div class="company-list">
                    <!-- {{companylist[0]._source.name}} -->
                    <a-card size="small" title="推荐企业" >
                        <a slot="extra" href="#"><a-icon type="redo" />换一批</a>
                        <div class="company-info" v-for="item in companylist" :key="item._source.id" @click="showDrawer(item._source.id)">
                           <div class="lq-phone">
                               <a-button type="primary" :loading="loading" @click="receivephone(item._source.id)">立即领取</a-button>
                               <p>手机号{{item._source.total_contact_num}}条</p>
                           </div>
                           <div class="company-head">
                               <div class="text-con">
                                   <span style="font-size: 21px;">{{item._source.company_desc}}</span>
                               </div>
                               <!-- <img src="../../../static/head.jpg" alt=""> -->
                           </div>
                           <div class="info">
                               <h3>{{item._source.name}}</h3>
                               <section class="type">
                                   <span>联系方式{{item._source.total_contact_num}}个</span>
                                   <span v-if="item._source.industry">{{item._source.industry}}</span>
                                   <span v-if="item._source.status">{{item._source.status}}</span>
                               </section>
                               <section class="cz">
                                   <span>
                                       <span>法定代表:</span>
                                       <span>{{item._source.legal}}</span>
                                       <span class="block"></span>
                                   </span>
                                   <span>
                                       <span>注册资本:</span>
                                       <span>{{item._source.registermoney}}</span>
                                       <span class="block"></span>
                                   </span>
                                   <span>
                                       <span>成立日期:</span>
                                       <span>{{item._source.create_date}}</span>
                                   </span>
                               </section>
                                <p><span>地址：</span>{{item._source.address}}</p>
                               <div class="tip">
                                   <span>基本信息(6)</span>
                                   <span>招聘信息(1)</span>
                                   <span>知识产权(2)</span>
                               </div>
                           </div>
                       </div>

                    </a-card>
                </div>
                <div class="company-news">
                    <a-card size="small" title="企业动态" >
                        <!-- <a slot="extra" href="#">查看更多<a-icon type="right" /></a> -->
                        <div class="news-list">
                           <a-empty :image="simpleImage" description="暂无数据"/>
                        </div>
                    </a-card>
                </div>
            </div>

        </div>
      

    <a-drawer
      placement="right"
      :closable="false"
      :visible="visible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      width="1024"
      class="tc"
    >
      <div class="company-content">
          <section class="left">
              <div class="top-info" v-if="companydetail">
                    <div class="company-info" style="background:#fff" >
                        <div class="lq-phone">
                            <a-button type="primary" :loading="loading" @click="receivephone(companydetail._source.id)">一键领取</a-button>
                        </div>
                        <div class="company-head">
                            <img src="../../../static/head.jpg" alt="">
                        </div>
                        <div class="info">
                            <h3>{{companydetail._source.name}} <span>{{companydetail._source.check_date}}更新</span></h3>
                            <section class="type">
                                <span>联系方式{{companydetail._source.total_contact_num}}个</span>
                                <span>{{companydetail._source.industry}}</span>
                                <span>{{companydetail._source.status}}</span>
                            </section>
                            <section class="cz">
                                <span>
                                    <span>法定代表:</span>
                                    <span>{{companydetail._source.legal}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>注册资本:</span>
                                    <span>{{companydetail._source.registermoney}}</span>
                                    <span class="block"></span>
                                </span>
                                <span>
                                    <span>成立日期:</span>
                                    <span>{{companydetail._source.create_date}}</span>
                                </span>
                            </section>
                            <p><span>地址：</span>{{companydetail._source.address}}</p>
                        </div>
                    </div>


                    <div class="all-info">
                        <a-tabs default-active-key="1">
                            <a-tab-pane key="1" tab="基本信息" v-if="companydetail">
                                <div class="s-menu">
                                    <span><a href="">企业简介</a></span>
                                    <span><a href="">工商信息</a></span>
                                    <span><a href="">股东信息1</a></span>
                                    <span><a href="">主要人员2</a></span>
                                    <span><a href="">工商变更2</a></span>
                                </div>

                                <div class="vistor-basic-info">
                                    <!-- <div class="info-extend">
                                        <div class="title"> 
                                            <span class="block"></span>
                                            <span class="font">企业简介</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="text">
                                                <span>微盟是一家专门针对微信公众账号提供营销推广服务的第三方平台，主要功能是针对微信商家公众号提供与众不同的、有针对性的营销推广服务。上海晖硕信息科技有限公司旗下产品。</span>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">工商信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <a-descriptions bordered :column="2">
                                                <a-descriptions-item label="统一社会信用代码">{{companydetail._source.creditcode}}</a-descriptions-item>
                                                <a-descriptions-item label="所属人">{{companydetail._source.legal}}</a-descriptions-item>
                                                <a-descriptions-item label="组织机构代码">{{companydetail._source.organizationcode}}</a-descriptions-item>
                                                <a-descriptions-item label="经营状态">{{companydetail._source.status}}</a-descriptions-item>
                                                <a-descriptions-item label="法定代表人">{{companydetail._source.legal}}</a-descriptions-item>
                                                <a-descriptions-item label="注册资本">{{companydetail._source.registermoney}}</a-descriptions-item>
                                                <a-descriptions-item label="公司类型">{{companydetail._source.companytype}}</a-descriptions-item>
                                                <a-descriptions-item label="成立日期">{{companydetail._source.create_date}}</a-descriptions-item>
                                                <a-descriptions-item label="营业期限">--</a-descriptions-item>
                                                <a-descriptions-item label="登记机关">--</a-descriptions-item>
                                                <a-descriptions-item label="核准日期">{{companydetail._source.check_date}}</a-descriptions-item>
                                                <a-descriptions-item label="公司规模">{{companydetail._source.insurancenum}}</a-descriptions-item>
                                                <a-descriptions-item label="纳税人识别号">{{companydetail._source.taxpayernum}}</a-descriptions-item>
                                                <a-descriptions-item label="所属行业">{{companydetail._source.industry}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="曾用名">{{companydetail._source.oldname}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="企业地址">{{companydetail._source.address}}</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="经营范围">{{companydetail._source.scope}}</a-descriptions-item>
                                            </a-descriptions>
                                        </div>
                                    </div>

                                    <!-- <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">股东信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content gdinfo">
                                            <section>
                                                <div class="name">苏州工业园区八二五新媒体投资企业（有限合伙）</div>
                                                <p>持股比例：4.362%</p>
                                                <p>认缴出资日期：--</p>
                                                <p>认缴出资额：274.9442万元</p>
                                            </section>

                                            <section>
                                                <div class="name">苏州工业园区八二五新媒体投资企业（有限合伙）</div>
                                                <p>持股比例：4.362%</p>
                                                <p>认缴出资日期：--</p>
                                                <p>认缴出资额：274.9442万元</p>
                                            </section>
                                        </div>
                                    </div>

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">主要人员</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content mainpeople">
                                            <section>
                                                <div>
                                                    <img src="../../../static/head.png" alt="">
                                                </div>
                                                <div class="info">
                                                    <p>刘志平</p>
                                                    <p>执行董事兼总经理</p>
                                                </div>
                                            </section>
                                        </div>
                                    </div>

                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">工商变更</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="informationRight" style="padding-left:0;margin-left:0">
                                                <div class="basicinfo">
                                                    <a-timeline>
                                                        <a-timeline-item>
                                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                                            <div class="date-arrow">10/20</div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>
                                                            <div class="description">
                                                                <div class="dataContainer">
                                                                    <span class="follow-title">电话呼出</span>
                                                                    <span class="follow-date"><a-icon type="clock-circle"/>10/20 17:03</span>

                                                                    <div><p>接通状态：已接听</p></div>
                                                                    <div><p>通话对象：万先生</p></div>
                                                                    <div class="RecordingAudio">

                                                                    </div>

                                                                    <div><p>来自客户：<a href="JavaScript:;">万先生</a></p></div>
                                                                    <div class="cz-user"><span>操作人：程先生</span></div>
                                                                </div>

                                                            
                                                            </div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                                        <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>
                                                    </a-timeline>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                </div>

                            </a-tab-pane>
                            <!-- <a-tab-pane key="2" tab="经营状况" force-render disabled>
                                 <div class="s-menu">
                                    <span><a href="">企业动态</a></span>
                                    <span><a href="">融资历史</a></span>
                                    <span><a href="">招投标</a></span>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">融资历史</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <div class="informationRight" style="padding-left:0;margin-left:0">
                                                <div class="basicinfo">
                                                    <a-timeline>
                                                        <a-timeline-item>
                                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                                            <div class="date-arrow">10/20</div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>
                                                            <div class="description">
                                                                <div class="dataContainer">
                                                                    <span class="follow-title">电话呼出</span>
                                                                    <span class="follow-date"><a-icon type="clock-circle"/>10/20 17:03</span>

                                                                    <div><p>接通状态：已接听</p></div>
                                                                    <div><p>通话对象：万先生</p></div>
                                                                    <div class="RecordingAudio">

                                                                    </div>

                                                                    <div><p>来自客户：<a href="JavaScript:;">万先生</a></p></div>
                                                                    <div class="cz-user"><span>操作人：程先生</span></div>
                                                                </div>

                                                            
                                                            </div>
                                                        </a-timeline-item>
                                                        <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                                        <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item>
                                                    </a-timeline>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="3" tab="招聘信息" disabled>
                                <div class="s-menu">
                                    <span><a href="">招聘情况</a></span>
                                    <span><a href="">招聘岗位</a></span>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">招聘情况</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content">
                                            <a-descriptions bordered :column="2">
                                                <a-descriptions-item label="招聘渠道">6(看准网、职友集、其他、百度招聘、BOSS直聘、58同城)</a-descriptions-item>
                                                <a-descriptions-item label="岗位业务关键词">BD、运营、店长、项目、前端、公关、金融、商务、招聘、视觉、采购、人事、视频、推广、高级、客户、培训、广告、客服、法务、Java、行政、技术、网络、测试、人力、架构师、营销、文案、数据、媒介、产品、研发、市场、编辑、安全、运维、物流、新媒体、销售、审核</a-descriptions-item>
                                                <a-descriptions-item label="岗位职级关键词	">其他</a-descriptions-item>
                                                <a-descriptions-item label="当前招聘岗位数	">--</a-descriptions-item>
                                                <a-descriptions-item label="当前招聘人数">跟进中</a-descriptions-item>
                                                <a-descriptions-item label="平均薪资">--</a-descriptions-item>
                                                <a-descriptions-item :span="3" label="招聘城市">--</a-descriptions-item>
                                            </a-descriptions>
                                        </div>
                                    </div>
                                </div>

                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">招聘岗位</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content zpgw">
                                             <section>
                                                <div class="name">媒介采购J10391</div>
                                                <p>招聘城市：上海市</p>
                                                <p>平均薪资：￥7000-13000</p>
                                                <p>招聘渠道：看准网</p>
                                                <p>发布时间：2017-11-19</p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="4" tab="媒体信息" disabled>
                                 <div class="s-menu">
                                    <span><a href="">官方网站</a></span>
                                    <span><a href="">网络推广</a></span>
                                    <span><a href="">公众号 11</a></span>
                                    <span><a href="">微博 4</a></span>
                                </div>
                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">官方网站</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content office">
                                             <section>
                                                <div class="name">www.weiwin.net</div>
                                                <p>官网名称：上海微盟科技股份有限公司</p>
                                                <p>备案号：沪ICP备17019238号-2</p>
                                                <p>审核时间：2017-06-14网</p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane key="5" tab="产品信息" force-render disabled>
                                
                            </a-tab-pane>
                            <a-tab-pane key="6" tab="知识产权" disabled>
                                <div class="s-menu">
                                    <span><a href="">商标信息 6</a></span>
                                    <span><a href="">专利信息 0</a></span>
                                </div>
                                <div class="vistor-basic-info">
                                    <div class="info-extend">
                                        <div class="title">
                                            <span class="block"></span>
                                            <span class="font">商标信息</span>
                                            <span class="cz">收起<a-icon type="down" /></span>
                                        </div>
                                        <div class="content sbinfo">
                                            <section>

                                                <p>商标类别：35 - 广告销售</p>
                                                <p>申请时间：2013-05-31</p>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane> -->
                        </a-tabs>

                    </div>
              </div>
        </section>
        <section class="right" v-if="companydetail">
            <div>
                <section class="company-phone-tabs">
                    <section class="phone-index-top-info">
                        <div class="company-phone-index-left">
                            <span>联系方式</span>
                            <a-popover placement="bottomRight">
                                <template slot="content">
                                    <p style="width:210px">所有信息均来自互联网公开数据，如您认为有侵犯到您的个人信息或隐私，请联系客服进行处理。</p>
                                </template>
                                <a-icon type="info-circle" />
                            </a-popover>
                        </div>
                    </section>
                    <a-divider />
                    <section class="phone-index-source-type">
                        <span @click="switchphone(0,companydetail._source.id)"  :class="{phonetype:0==current}">全部({{companydetail._source.total_tel_num+companydetail._source.total_mobile_num}})</span>
                        <span @click="switchphone(1,companydetail._source.id)" :class="{phonetype:1==current}">手机({{companydetail._source.total_mobile_num}})</span>
                        <span @click="switchphone(2,companydetail._source.id)"  :class="{phonetype:2==current}">固话({{companydetail._source.total_tel_num}})</span>
                    </section>
                </section>
            </div>
            <div>
                <div class="phone-card-item">
                    <div class="phone-index-phone" v-for="(item,i) in phone_list" :key="i">
                        <p>{{item}}</p>
                    </div>
                    <div class="item-receive-status">
                        <a-button :loading="loading" @click="receivephone(companydetail._source.id)">立即领取</a-button>
                    </div>
                </div>
                
            </div>
            <!-- <a-tabs default-active-key="1" >
                <a-tab-pane key="1" tab="手机">
                </a-tab-pane>
                <a-tab-pane key="2" tab="固话" force-render>
                </a-tab-pane>
                <a-tab-pane key="3" tab="邮箱">
                </a-tab-pane>
            </a-tabs>

            <div class="getPhone">
                <section>
                    <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
                    <a-button size="small" icon="import">领取</a-button>
                </section>

                <div class="phoneCard phone-active">
                    <div class="content ">
                        <div class="phone"><span>130****0783</span></div>
                        <div class="name"><span>姓名：孙**</span></div>
                        <div class="type">
                            <span>黄页</span>
                        </div>
                    </div>
                </div>

                 <div class="phoneCard">
                    <div class="content ">
                        <div class="phone"><span>130****0783</span></div>
                        <div class="name"><span>姓名：孙**</span></div>
                        <div class="type">
                            <span>黄页</span>
                        </div>
                    </div>
                </div>
            </div> -->
        </section>
      </div>
    </a-drawer>
    </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      text:'',
      indeterminate: true,
      checkAll: false,
      serachmenu:[
        '智能搜索',
        '按公司',
        '按网站',
        '按地址',
        '按号码',
      ],
      menucurrent:0,
      companylist:"",
      companydetail:"",
      phone_list:"",
      current:0,

      loading:false
    };
  },
   beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  mounted(){
    this.$axios.get("/api/getqcclist",{
        headers: {
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
    }).then((res)=>{
        if(res.data.code==200){
        this.companylist=res.data.data.lists
        // console.log(this.companylist[0]._source.name)
        }else{
            this.$message.error(res.data.msg); 
        }
    })
  },
  methods: {

    //   领取电话
    receivephone(value){
        this.loading=true
        this.$axios.get("/api/receiveqcc",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:value
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.loading=false
                this.$message.success(res.data.msg); 
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },

    //   切换
    switchphone(value,id){
        this.current=value
         this.$axios.get("/api/getqccdetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:id
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.visible = true;
                this.companydetail=res.data.data
                var all=[]
                if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list!=undefined){
                    all=res.data.data._source.phone_total
                }else if(res.data.data._source.phone_list==undefined&&res.data.data._source.tel_list!=undefined){
                    all=res.data.data._source.tel_list
                }else if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list==undefined){
                    all=res.data.data._source.phone_list
                }

                for(var i in all){
                    all[i]=all[i].substr(0,3)+'****'+all[i].substr(7);
                }
                var phonelist=res.data.data._source.phone_list
                var tellist=res.data.data._source.tel_list
                for(var i in phonelist){
                    phonelist[i]=phonelist[i].substr(0,3)+'****'+phonelist[i].substr(7);
                }
                for(var i in tellist){
                    tellist[i]=tellist[i].substr(0,3)+'****'+tellist[i].substr(7);
                }

                if(value==1){
                    this.phone_list=phonelist
                }else if(value==2){
                    this.phone_list=tellist
                }else if(value==0){
                    this.phone_list=all
                }
  
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },
    switchmenu(value){
        this.menucurrent=value
    },
    onSearch(value) {
        this.$router.push({
            path:'/search',
            query: {name:value}
        })
    },
    // 抽屉
    showDrawer(value) {
      this.$axios.get("/api/getqccdetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:value
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.visible = true;
                this.companydetail=res.data.data
                var all=[]
             
                if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list!=undefined){
                    all=res.data.data._source.phone_total
                }else if(res.data.data._source.phone_list==undefined&&res.data.data._source.tel_list!=undefined){
                    all=res.data.data._source.tel_list
                }else if(res.data.data._source.phone_list!=undefined&&res.data.data._source.tel_list==undefined){
                    all=res.data.data._source.phone_list
                }
                for(var i in all){
                    all[i]=all[i].substr(0,3)+'****'+all[i].substr(7);
                }
                this.phone_list=all
            }else{
                this.$message.error(res.data.msg); 
            }
        })
    },
    onClose(){
        this.visible=false
    },
    // 全选/反选
    onCheckAllChange(){

    },
    afterVisibleChange() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/toker/searvistor.vue